import { useState } from "react";
import { classNames } from "../App";
import EyeIcon from "../icons/eye";
import EyeSlashIcon from "../icons/eyeslash";

// A password field that can be read back. Our passwords have to satisfy three
// rules at once, and typing one of those blind is how a typo ends up saved and
// the person locked out of an account they just created — so every field that
// takes a password gets the same toggle. It starts hidden: revealing is a
// deliberate act, not the default, since these get typed in open-plan offices.
//
// The styling is left entirely to the caller, because password fields live in
// two different worlds here — the DaisyUI login cards and the plain
// CustomTextInput forms — and the field has to look like its neighbours in
// both. Pass the same className the text input next to it uses.
//
// fullWidth tracks how the input is laid out: the toggle is positioned against
// the wrapper, so the wrapper has to end where the input ends. Stacked forms
// want the default; a row of inputs sized to their content wants false.
export default function CustomPasswordInput({
    className,
    register,
    placeholder,
    fullWidth = true,
    showLabel = "Arată parola",
    hideLabel = "Ascunde parola",
    ...rest
}) {

    const [visible, setVisible] = useState(false);

    return (
        <div className={classNames("relative", fullWidth ? "w-full" : "inline-block")}>
            <input
                type={visible ? "text" : "password"}
                placeholder={placeholder}
                className={classNames(className, fullWidth ? "w-full" : "", "pr-11")}
                {...register}
                {...rest}
            />
            <button
                type="button"
                onClick={() => setVisible(!visible)}
                // The toggle is not part of the form: reaching it with Tab on
                // the way to the submit button would be a detour every time.
                tabIndex={-1}
                aria-label={visible ? hideLabel : showLabel}
                title={visible ? hideLabel : showLabel}
                className="absolute inset-y-0 right-3 flex items-center text-neutral-400 hover:text-neutral-1100 focus:outline-none"
            >
                {visible
                    ? <EyeSlashIcon className="h-5 w-5" />
                    : <EyeIcon className="h-5 w-5" />}
            </button>
        </div>
    )
}
